import React, {useState} from 'react';
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/CloseRounded";
import './style.scss'
import InputAdornment from "@material-ui/core/InputAdornment";
import Input from "@material-ui/core/Input";


export default function AddOweDialog(props) {
    const [oweAmount, setOweAmount] = useState(0);
    const [oweReason, setOweReason] = useState("");

    function onClose() {
        if (props.onCloseRequest)
            props.onCloseRequest();
    }

    function onAdd() {
        if (!oweAmount || oweAmount <= 0)
            return;

        if (props.onAddRequest)
            props.onAddRequest(oweAmount, oweReason);
    }

    function onOweAmountChange(event) {
        if (event.target.value === "")
            setOweAmount(0);
        else
            setOweAmount(parseInt(event.target.value));
    }

    function onOweReasonChanged(event) {
        setOweReason(event.target.value);
    }

    return (
        <Dialog className="add-owe-dialog" open={props.isOpen} onClose={onClose}>
            <DialogTitle>חוב חדש</DialogTitle>
            <DialogContent className="dialog-content">
                <div className="owe-amount-line">
                    סכום:
                    <Input
                        autoFocus
                        className="owe-amount-input"
                        value={oweAmount}
                        onChange={onOweAmountChange}
                        startAdornment={<InputAdornment className="input-adornment" position="start">₪</InputAdornment>}
                        error={!oweAmount || oweAmount <= 0}
                    />
                </div>
                <div className="owe-reason-line">
                    סיבה:
                    <Input
                        className="owe-reason-input"
                        placeholder="מה הסיבה לחוב?"
                        value={oweReason}
                        onChange={onOweReasonChanged}
                        error={!oweReason || oweReason === ""}
                        multiline
                    />
                </div>
            </DialogContent>
            <DialogActions className="dialog-actions">
                <IconButton className="close-button"
                            onClick={onClose}>
                    <CloseIcon fontSize="small"/>
                </IconButton>
                <Button variant="contained" color="primary" onClick={onAdd}
                        disabled={!oweAmount || oweAmount <= 0 || !oweReason || oweReason === ""}>
                    הוסף
                </Button>
            </DialogActions>
        </Dialog>
    );
}